"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _constants = require("../constants");
const styleOverrides = {
  fab: {
    backgroundColor: _constants.colors.commonColors.white,
    color: _constants.colors.text.primary
  },
  staticTooltipLabel: {
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: _constants.colors.commonColors.white,
    fontWeight: 'bold',
    padding: '4px 12px'
  },
  tooltipPlacementLeft: {
    '& .MuiSpeedDialAction-staticTooltipLabel': {
      marginRight: 0
    }
  }
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiSpeedDialAction.js.map